/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flow_CollectionInputs */

const en_flow_collection = /** @type {(inputs: Flow_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A collection`)
};

/**
* | output |
* | --- |
* | "A collection" |
*
* @param {Flow_CollectionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const flow_collection = /** @type {((inputs?: Flow_CollectionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_CollectionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_flow_collection(inputs)
});